import { create } from 'zustand';

type Language = 'en' | 'fi' | 'se' | 'es';

interface LanguageState {
  currentLanguage: Language;
  setLanguage: (language: Language) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  currentLanguage: (localStorage.getItem('language') as Language) || 'en',
  setLanguage: (language) => {
    localStorage.setItem('language', language);
    set({ currentLanguage: language });
  },
}));

